<template>

        <!-- Modal -->
        <div class="modal fade"  :class="{ show: false, 'd-block': false }"  id="crusade_typeModal"    aria-labelledby="crusade_typeModalLabel" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" style="max-height:30%; max-width: 80%;" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="crusade_typeModalLabel" v-if="crusade_type_view_type=='add'">Add Crusade Type</h5>
                <h5 class="modal-title" id="crusade_typeModalLabel" v-else-if="crusade_type_view_type=='edit'">Edit Crusade Type</h5>
                <h5 class="modal-title" id="crusade_typeModalLabel" v-else-if="crusade_type_view_type=='view'">View Crusade Type</h5>
                <button type="button" class="btn-close" :data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#crusade_typeModal" aria-label="Close"></button>
            </div>
              <div v-if="this.crusade_type_view_type=='add' || this.crusade_type_view_type=='edit'">
              <form class="register-form" @submit.prevent="reg()">
            <div class="modal-body">

                <div class="card shadow-sm" id="stylized">
                   
                                <!-- <div class="card-body"> -->


                    <div class="card-body">
                      <h1 v-if="crusade_type_view_type == 'add'">Add Crusade Type</h1>
                      <h1 v-else-if="crusade_type_view_type == 'edit'">Edit Crusade Type</h1>
                      <br/>
                      <p></p>
        
                  <span>
                  
           




                      <div class="row">

                <div class="col">
                        <label>Crusade Type</label>
                        <div class="input-group">
                          

                          <input
                            type="text"
                            class="form-control"
                            :class="{ form_error: crusade_typeErr}"
                            placeholder="Crusade Type"
                            @blur="crusade_typeVal($event.target.value)" 
                            v-model.trim="formData.crusade_type"
                          />
                         
                        </div>
                         <div
                            :class="{ text_error: crusade_typeErr  }"
                           v-if="crusade_typeErr">
                          {{ crusade_typeErr }} 
                          </div>
                      </div>







                     <div class="col">
                              <label>Is Active</label>
                            <div class="input-group">
                          
                          <select
                            class="form-control"
                            :class="{ form_error: is_activeErr}"
                             @change="is_activeVal($event.target.value)"
                            v-model.trim="formData.is_active">
                            <option value="">--Choose An Option--</option>
                            <option value="YES">YES</option>
                            <option value="NO">NO</option>
                          </select>
                          
                          
                        </div>
                        <div
                            :class="{ text_error: is_activeErr}"
                            v-if="is_activeErr"
                          >
                            {{ is_activeErr }}
                          </div>
                      </div>

         



                     




                    </div>



                  </span>
                    </div>



                    

                                </div>
                
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" v-if="crusade_type_view_type=='add'">Submit</button>
                <button type="submit" class="btn btn-primary" v-if="crusade_type_view_type=='edit'">Update</button>
                <button type="button" class="btn btn-danger" @click="remove_all" v-if="crusade_type_view_type=='add'">Clear All</button>
                <button type="button" class="btn btn-secondary" ref="crusade_type_modal_ref" data-bs-dismiss="modal" v-if="crusade_type_view_type=='edit'">Close</button>
            </div>

                  </form>
                  </div>


                 <div v-else>
                      <div class="modal-body">
                        <div class="table-responsive table-responsive-data2">
                        <table class="table table-hover table-striped">
                          
                              <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Value</th>
                                </tr>
                                </thead>


                                <tbody>
                                <tr>
                                <td>Crusade Type</td>
                                <td>{{formData.crusade_type}}</td>
                                </tr>

                               <tr>
                                <td>Is Active</td>
                                <td>{{formData.is_active}}</td>
                                </tr>




                 
                              </tbody>
                                  </table>









                                                                

                    
                        </div>

                      </div>

                 </div>


            </div>
        </div>


        
        </div>
</template>

<script>
 import axios from 'axios';
import FieldValidateService from "@/services/FieldValidateService";
import notificationBox from "@/services/notificationBox";
//import SpinnerComp from "@/components/SpinnerComp.vue";
import { mapActions, mapMutations } from 'vuex';
import { DEPENDENT_LINK_REG, EDIT_DEPENDENT_LINK_REG, LOADING, RESET_DEPENDENT_SEARCH_RESULT, SEARCH_DEPENDENT } from '@/store/storeconstants';
//import VueMultiselect from 'vue-multiselect'
//import Select2 from 'vue3-select2-component';
//import vSelect from 'vue-select'

    export default {

        name:'CrusadeTypeModals',
        props:{
            crusade_type_view_type:{
                required:true,
            },

            crusade_type_data:{
                required:true,
            }
        },


           mounted(){

              // const input = document.querySelector("#telephone");
              // console.log(input);
              // intlTelInput(input,{
              //   // any initialisation options go here
              //       preferredCountries: ["gh", "us", "ca"],
                
                  
              // });

             //   console.log(localStorage.getItem("token"));

           },

        async created() {

  
  
 

        },




         data: function () {
    return {
      //userModal: null,
      link_val:"",
      app_portal: "",
      loading:false,
      errorMess: "",
      succMess:"",
      clear_user: true,
      clear_all: true,
      errorClient:[],
      errorServers:[],
       modal:"modal",


   
      

      formData: {
        portal:"",
        crusade_type_id:"",

        crusade_type: "",
        is_active: "",
        view_type:"",
        user_id:1,
        
        
      },



    //Errors  
      crusade_typeErr: "",
      is_activeErr: "",






    };
  },


      methods: {

          ...mapActions({
            search_dependent: 'dependent/'+SEARCH_DEPENDENT,
            link_dependent_support: 'dependent/'+DEPENDENT_LINK_REG,
            edit_link_dependent_support:'dependent/'+EDIT_DEPENDENT_LINK_REG
          }),




         ...mapMutations({
                 reset_dependent_search_result: 'dependent/'+RESET_DEPENDENT_SEARCH_RESULT,
                 showLoading:LOADING,
         }),







       async reg(){
      
      //notificationBox.successAlert("Registration Successful","An Email Has Been Sent To You. Please Click On The Link To Verify Your Account") 
       //console.log(this.formData);
       // console.log(this.errorClient);
        this.errorServers = [];
       this.errorClient = [];
       this.showLoading(true);

        this.crusade_typeVal(this.formData.crusade_type);
        this.is_activeVal(this.formData.is_active);


   

             if(this.errorClient.length > 0)
       {
         this.showLoading(false);
          notificationBox.errorNotifications("Some Errors Exist");
          console.log(this.errorClient);
          return true;
       }

   




    if(this.crusade_type_view_type=="add"){


         try{
            const response = await axios.post("crusade_types",this.formData);
              if(response.status == 200)
              {
                   this.showLoading(false);

                     this.clearFormData();
        notificationBox.succNotifications("Crusade Type Added Successfully");
        this.$emit("crusade_typeAdded");
              }


         }catch(error){

               //  console.log(error);
           this.errorServers.push(error.response.data.error);
           
           this.showLoading(false);


               if(error.response.data.data_error)
       {
        notificationBox.errorNotifications(error.response.data.data_error);
       }
          

                  else if(this.errorServers.length > 0)
       {
           notificationBox.errorNotifications("Some Errors Exist");
            this.getServerError();
     
       }
    

         }
 



    }
    else if(this.crusade_type_view_type=="edit")
    {





         try{
            const response = await axios.patch(`crusade_types/${this.formData.crusade_type_id}`,this.formData);
              if(response.status == 200)
              {

                     this.showLoading(false);
                     this.$refs.crusade_type_modal_ref.click();
                     this.clearFormData();
        notificationBox.succNotifications("Crusade Type Edited Successfully");
        this.$emit("crusade_typeAdded");
              }


         }catch(error){

                // console.log(error);
           this.errorServers.push(error.response.data.error);
           
           this.showLoading(false);
        

          
               if(error.response.data.data_error)
       {
        notificationBox.errorNotifications(error.response.data.data_error);
       }
          

           else  if(this.errorServers.length > 0)
       {
             notificationBox.errorNotifications("Some Errors Exist");
            this.getServerError();
     
       }
     

         }
     

           


    }




    
    },





     clearFormData(){
        this.errorServers = [];
        this.errorClient = [];
      //this.clear_user = false;
      this.formData.crusade_type = "";
      this.formData.crusade_type_id = "";
      this.formData.is_active = "";
      this.crusade_typeErr = "";
      this.is_activeErr = "";

    },




   getServerError(){

       this.crusade_typeErr = 'crusade_type' in this.errorServers[0] ? this.errorServers[0].crusade_type[0] : '';
      this.is_activeErr = 'is_active' in this.errorServers[0] ? this.errorServers[0].is_active[0] : '';


     
           return true;

   },





     crusade_typeVal(value){

      let max = 500;
      let field = "Crusade Type"

         if(FieldValidateService.reqMaxStringVal(value, field,max))
     {
       this.crusade_typeErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.crusade_typeErr);
     }else{

           this.crusade_typeErr =""; 
          this.errorClient.pop(this.crusade_typeErr);

     }


    },







     is_activeVal(value) {

      let max = 10;
      let field = "Is Active";
     
     if(FieldValidateService.reqMaxStringVal(value,field,max))
     {
       this.is_activeErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.is_activeErr);
     }else{

           if(this.errorClient.includes(this.is_activeErr))
           {
            let pos = this.errorClient.indexOf(this.is_activeErr);
           this.errorClient.splice(pos,1);
            this.is_activeErr =""; 
           }
          
          

     }
    },







    




      





  

      },

      
  computed:{


    // ...mapState('dependent',['dependent_view_type','dependent_info','search_message','search_dependent_result']),
    // ...mapState('dependent_support',['dependent_support_view_type','dependent_support_info']),

    // firstName(){
    //   return this.checked_user_data.fullname;
    // }
  },  

    components: {
      //SpinnerComp,
      //vSelect
      //VueMultiselect
     // Select2
    },

    watch:{

 


   




        crusade_type_view_type(value){
          console.log(value);
           if(value == "add"){
        
           this.clearFormData();
           


           }
        },

        crusade_type_data(value){
       
         let data = value;
            //console.log(data);
            this.clearFormData();
            this.formData.crusade_type_id = data.id;
            this.formData.crusade_type = data.crusade_type;
            this.formData.is_active = data.is_active;
        
       
          
          
        },


    



    }
        
    }
</script>

<style scoped>


</style>